import type { CSSProperties } from 'react'
import type { TrustTierName } from './types'

/** Monochrome tier dot styles for inline badge (v4 tokens only). */
export function tierDotStyle(tier: TrustTierName): CSSProperties {
  switch (tier) {
    case 'platinum':
      return { background: 'var(--amber)', border: '1px solid var(--line)' }
    case 'gold':
      return { background: 'var(--amber)', opacity: 0.65, border: '1px solid var(--line)' }
    case 'silver':
      return { background: 'var(--ink2)', border: '1px solid var(--line)' }
    case 'bronze':
      return { background: 'var(--ink3)', border: '1px solid var(--line2)' }
    case 'review':
    default:
      return { background: 'transparent', border: '1px solid var(--line)' }
  }
}
